import async from 'async';
import axios from 'axios/index';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import Loader from 'react-loader-advanced';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import swal from 'sweetalert';
import Select from 'react-select';
import undefsafe from 'undefsafe';
import CommissionLabel from '../../../components/CommissionLabel';
import SalePackageLabel from '../../../components/SalePackageLabel';
import Button from '../../../components/CustomButton/CustomButton';
import * as K from '../redux/SalesConstants';
import AddHotel from './lodgingSaleAddHotel';

class lodgingSaleAdd extends Component {
  constructor(props) {
    super(props);

    this.roomDefault = {
      description: '',
      options: [
        {
          description: '',
          purchaseCost: '',
          saleCost: '',
        },
      ],
    };

    this.formDataDefault = {
      rooms: [this.roomDefault],
      hotel: {},
      operator: {},
    };

    this.addHotelDefault = {
      urlSource: '',
      name: '',
      address: '',
      description: '',
      images: [],
      imagesWeb: [],
    };

    this.state = {
      formData: this.formDataDefault,
      addHotel: this.addHotelDefault,
      createHotel: false,
      gettingHotel: {
        show: false,
        message: 'Iniciando...',
      },
      optionsSelect: {
        hotels: [],
        lastHotels: [],
      },
      edit: '',
      roles: [],
      requiredRoles: ['support', 'adminHotel'],
    };
  }

  componentWillMount() {
    const {
      user: { roles },
    } = this.props;

    this.getOptionsSelect(
      'operators',
      process.env.REACT_APP_URL_API + '/api/operators',
      (option) => {
        return {
          label: option.name,
          value: option.id,
        };
      },
    );

    if (roles) {
      this.setState({ roles });
    }
  }

  async componentWillReceiveProps(nextProps) {
    var _this = this;
    var newForm = nextProps.Sales.dataToEdit.lodging;
    if (newForm.hotel !== undefined) {
      const hotelId = newForm.hotel._id || newForm.hotel.id;

      var hotel = await axios.get(
        process.env.REACT_APP_URL_API + '/api/hotels/' + hotelId,
      );

      var hotelData = hotel.data;

      var newOptionsSelect = immutable.set(
        _this.state.optionsSelect,
        'hotels',
        [
          {
            value: hotelData['id'],
            label: hotelData['name'] + ' - ' + hotelData['address'],
            object: hotelData,
          },
        ],
      );

      _this.setState({
        edit: newForm,
        formData: newForm,
        optionsSelect: newOptionsSelect,
      });
    } else {
      this.setState({
        formData: this.formDataDefault,
        addHotel: this.addHotelDefault,
        createHotel: false,
        edit: '',
      });
    }
  }

  handledPrices = () => {
    if (this.state.formData.saleCost - 0 <= 0) {
      alert('El precio de venta debe ser mayor a 0');
    } else if (this.state.formData.purchaseCost - 0 <= 0) {
      alert('El precio de compra debe ser mayor a 0');
    } else {
      if (
        this.state.formData.purchaseCost - 0 <
        this.state.formData.saleCost - 0
      ) {
        this.onAdd();
      } else {
        alert(
          '¡Atención! El precio de venta es menor o igual al precio de compra',
        );
      }
    }
  };

  addHotel = async () => {
    //TODO Toño - Revisar y resolver que no se guardan los hoteles que se agregan manualmente.
    var _this = this;

    return new Promise(async function (resolve) {
      if (_this.state.addHotel.create) {
        var saveHotel = await axios.post(
          process.env.REACT_APP_URL_API + '/api/hotels',
          _this.state.addHotel,
        );
        let addHote = {
          id: saveHotel.data.id,
          name: saveHotel.data.name,
        };

        _this.setState({
          formData: {
            ..._this.state.formData,
            hotel: addHote,
          },
        });
      }
      resolve();
    });
  };

  onAdd = async () => {
    var _this = this;

    if (this.formLodgingAdd.reportValidity()) {
      async.forEachOf(
        this.state.formData.rooms,
        function (room, key, callback) {
          async.forEachOf(
            room.options,
            function (roomOptions, key, callbackRoom) {
              if (!roomOptions.purchaseCost || !roomOptions.saleCost) {
                callbackRoom('error');
              } else if (
                roomOptions.purchaseCost === '' ||
                roomOptions.saleCost === '' ||
                roomOptions.purchaseCost === 0 ||
                roomOptions.saleCost === 0
              ) {
                callbackRoom('error');
              } else {
                callbackRoom();
              }
            },
            function (err) {
              if (err) {
                alert(
                  'Debe de existir un precio de compra y venta en todas las habitaciones',
                );
                callback('error');
              } else {
                callback();
              }
            },
          );
        },
        async function (err) {
          if (!err) {
            if (_this.state.edit.hotel !== undefined) {
              await _this.addHotel();

              _this.props.dispatch({
                type: K.UPDATE_LODGING,
                payload: {
                  data: {
                    value: _this.state.formData,
                    index: _this.props.Sales.indexToEdit,
                  },
                },
              });
            } else {
              await _this.addHotel();

              _this.props.dispatch({
                type: K.ADD_LODGING,
                payload: _this.state.formData,
              });
            }

            _this.props.dispatch({
              type: K.CLOSE_MODAL_ADD,
              payload: 'lodging',
            });

            _this.setState({
              formData: _this.formDataDefault,
              addHotel: _this.addHotelDefault,
              createHotel: false,
              gettingHotel: {
                show: false,
                message: 'Iniciando...',
                loading: false,
              },
              edit: '',
            });
          }
        },
      );
    }
  };

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    const response = await axios.get(url);

    const options = response.data
      .filter((option) => option.isDeleted !== true)
      .map(optionCreateFunction)
      .sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        return labelA.localeCompare(labelB);
      });

    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
    });
  };

  search = (inputValue) => {
    let _this = this;
    const { roles, requiredRoles } = _this.state;

    if (inputValue !== '') {
      _this._inputValue = inputValue;

      _this.setState({ isLoadingHotel: true });

      const param = {
        where: {
          or: [
            { name: { like: encodeURIComponent(inputValue), options: 'i' } },
          ],
          isDeleted: {
            neq: true,
          },
        },
        limit: 50,
      };

      axios
        .get(
          process.env.REACT_APP_URL_API +
          '/api/hotels/?filter=' +
          JSON.stringify(param),
        )
        .then(function (result) {
          var selectData = [];
          result.data.map(function (item) {
            selectData.push({
              value: item['id'],
              label: item['name'] + ' - ' + item['address'],
              object: item,
            });
          });

          let foundRoles = [];
          requiredRoles.forEach((role) => {
            if (roles.includes(role)) {
              foundRoles.push(role);
            }
          });

          if (inputValue !== '' && foundRoles.length > 0) {
            selectData.push({
              value: inputValue,
              label: 'Crear a ' + inputValue,
              className: 'Select-create-option-placeholder',
            });
          }

          var newOptionsSelect = immutable.set(
            _this.state.optionsSelect,
            'hotels',
            selectData,
          );

          _this.setState({
            optionsSelect: newOptionsSelect,
            isLoadingHotel: false,
          });
        })
        .catch(function (error) {
          console.log('Error: ', error);
        });
    } else {
      if (_this.state.optionsSelect.lastHotels.length > 0) {
        var newOptionsSelect = immutable.set(
          _this.state.optionsSelect,
          'hotels',
          _this.state.optionsSelect.lastHotels,
        );

        _this.setState({
          optionsSelect: newOptionsSelect,
          isLoadingHotel: false,
        });
      }
    }
  };

  renderOption = (option) => {
    if (option.reaction !== undefined) {
      return (
        <div>
          <Highlighter
            searchWords={[this._inputValue]}
            textToHighlight={option.label}
          />
        </div>
      );
    } else {
      return option.label;
    }
  };

  onCloseModal = () => {
    this.setState({
      formData: this.formDataDefault,
      addHotel: this.addHotelDefault,
      createHotel: false,
      gettingHotel: {
        show: false,
        message: 'Iniciando...',
      },
    });
    this.props.dispatch({
      type: K.CLOSE_MODAL_ADD,
      payload: 'lodging',
    });
  };

  onChangeSelect = (path, pathSelect, value) => {
    if (value) {
      if (value.className === 'Select-create-option-placeholder') {
        var newFormData = immutable.set(this.state.formData, path, {});
        var newAddHotelDefault = immutable.set(
          this.addHotelDefault,
          'name',
          value.value,
        );
        var newCreateHotel = true;
      } else {
        var newFormData = immutable.set(
          this.state.formData,
          path,
          value.object,
        );
        var newCreateHotel = false;
        var newAddHotelDefault = this.addHotelDefault;
      }
    } else {
      var newFormData = immutable.set(this.state.formData, path, '');
      var newCreateHotel = false;
      var newAddHotelDefault = this.addHotelDefault;
    }
    this.setState({
      formData: newFormData,
      createHotel: newCreateHotel,
      addHotel: newAddHotelDefault,
      // optionsSelect: newOptionsSelect
    });
  };

  onChangeOperator = (path, value) => {
    if (value) {
      var newFormData = immutable.set(this.state.formData, path, value.value);
    } else {
      var newFormData = immutable.set(this.state.formData, path, '');
    }
    this.setState({
      formData: newFormData,
    });
  };

  onChange = (path, value) => {
    if (value) {
      var newFormData = immutable.set(this.state.formData, path, value);
    } else {
      var newFormData = immutable.set(this.state.formData, path, '');
    }

    this.setState({
      formData: newFormData,
    });
  };

  onChangeHotel = (path, value) => {
    var newAddHotel = immutable.set(this.state.addHotel, path, value);

    this.setState({
      addHotel: newAddHotel,
    });
  };

  alertInfo = async (msg) => {
    await swal('Atención!!', msg, {
      icon: 'warning',
      timer: 2500,
      buttons: false,
    });
  };

  resetFormValue({ type, message, indexRoom, indexOption }) {
    this.alertInfo(message);
    const newFormData = immutable.set(
      this.state.formData,
      ['rooms', indexRoom, 'options', indexOption, type],
      '',
    );
    this.setState({
      formData: newFormData,
    });
  }

  onChangeVerify = (type, indexRoom, indexOption, value) => {
    return;
  };

  addRoom = () => {
    var newFormData = immutable.push(
      this.state.formData,
      'rooms',
      this.roomDefault,
    );
    this.setState({
      formData: newFormData,
    });
  };

  removeRoom = (indexRoom) => {
    var newFormData = immutable.del(this.state.formData, ['rooms', indexRoom]);
    this.setState({
      formData: newFormData,
    });
  };

  addOption = (indexRoom) => () => {
    var newFormData = immutable.push(
      this.state.formData,
      ['rooms', indexRoom, 'options'],
      this.roomDefault,
    );
    this.setState({
      formData: newFormData,
    });
  };

  removeOption = (indexRoom, indexOption) => () => {
    var newFormData = immutable.del(this.state.formData, [
      'rooms',
      indexRoom,
      'options',
      indexOption,
    ]);
    this.setState({
      formData: newFormData,
    });
  };

  gettingHotel = (show, message) => {
    console.log('params', { show, message });
    this.setState({
      gettingHotel: {
        show: show,
        message: message,
      },
    });
  };

  render() {
    const { formData, optionsSelect } = this.state;
    const {
      Sales: {
        modalAddStatus,
        salesInformation: { isPackage = false },
      },
    } = this.props;

    return (
      <Modal
        open={undefsafe(modalAddStatus, 'lodging') || false}
        onClose={this.onCloseModal}
        styles={{ modal: { width: '100%' } }}
        closeOnOverlayClick={false}
      >
        <Loader
          show={this.state.gettingHotel.show}
          message={this.state.gettingHotel.message}
        >
          <Grid fluid>
            <form
              ref={(ref) => {
                this.formLodgingAdd = ref;
              }}
            >
              <Row>
                <Col md={12}>
                  <h3>Agregar Hospedaje</h3>
                  <SalePackageLabel isPackage={isPackage} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="name" style={{ fontWeight: '400' }}>
                      HOTEL
                    </label>
                    <Select
                      isClearable
                      placeholder="-- Seleccionar"
                      name="operator"
                      value={
                        formData.hotel._id !== undefined
                          ? formData.hotel._id
                          : formData.hotel.id
                      }
                      options={optionsSelect.hotels}
                      isLoading={this.state.isLoadingHotel}
                      onInputChange={this.search}
                      optionRenderer={this.renderOption}
                      onChange={(value) => {
                        this.onChangeSelect('hotel', ['lastHotels'], value);
                      }}
                    />
                    <input
                      style={{
                        height: 1,
                        padding: 0,
                        margin: 0,
                        border: 0,
                        color: 'white',
                      }}
                      required={!this.state.createHotel}
                      type="text"
                      id="userIdHidden"
                      value={
                        formData.hotel._id !== undefined
                          ? formData.hotel._id
                          : formData.hotel.id
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {this.state.createHotel && (
                    <AddHotel
                      formData={this.state.addHotel}
                      onChange={this.onChangeHotel}
                      onGettingHotel={this.gettingHotel}
                      onCancel={this.cancelGetHotel}
                      onRef={(ref) => {
                        this.AddhotelRef = ref;
                      }}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="name" style={{ fontWeight: '400' }}>
                      OPERADOR
                    </label>
                    <Select
                      placeholder="-- Seleccionar"
                      name="operator"
                      required={true}
                      value={
                        (formData.operator && formData.operator._id) ||
                        formData.operator
                      }
                      options={optionsSelect.operators}
                      onChange={(value) =>
                        this.onChangeOperator('operator', value)
                      }
                    />
                  </div>
                </Col>
              </Row>
              {formData.rooms.map((room, indexRoom) => (
                <div key={indexRoom}>
                  <Row>
                    <Col md={10}>
                      <div className="form-group">
                        <label htmlFor="descriptionRoom" style={{ fontWeight: '400' }}>
                          <strong>
                            DESCRIPCIÓN DE HABITACIÓN {indexRoom + 1}
                          </strong>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="descriptionRoom"
                          value={room.description}
                          onChange={(event) =>
                            this.onChange(
                              ['rooms', indexRoom, 'description'],
                              event.target.value,
                            )
                          }
                        />
                      </div>
                    </Col>
                    <Col md={2}>
                      <Button
                        bsStyle="danger"
                        className="pull-right"
                        onClick={() => this.removeRoom(indexRoom)}
                        style={{ marginTop: 25 }}
                      >
                        Eliminar
                      </Button>
                    </Col>
                  </Row>

                  {room.options.map((option, indexOption) => (
                    <Row key={indexOption} style={{ marginLeft: 2 }}>
                      <Row>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              htmlFor="buyprice"
                              style={{
                                fontWeight: '400',
                              }}
                            >
                              TARIFA NETA
                            </label>
                            <input
                              type="number"
                              min="1"
                              step="any"
                              required={true}
                              className="form-control"
                              id="buyprice"
                              value={option.purchaseCost}
                              onBlur={(event) =>
                                this.onChangeVerify(
                                  'purchaseCost',
                                  indexRoom,
                                  indexOption,
                                  event.target.value,
                                )
                              }
                              onChange={(event) =>
                                this.onChange(
                                  [
                                    'rooms',
                                    indexRoom,
                                    'options',
                                    indexOption,
                                    'purchaseCost',
                                  ],
                                  event.target.value,
                                )
                              }
                            />
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              htmlFor="saleCost"
                              style={{
                                fontWeight: '400',
                              }}
                            >
                              TARIFA PÚBLICA
                            </label>
                            <input
                              type="number"
                              min="1"
                              step="any"
                              required
                              className="form-control"
                              id="saleCost"
                              value={option.saleCost}
                              onBlur={(event) =>
                                this.onChangeVerify(
                                  'saleCost',
                                  indexRoom,
                                  indexOption,
                                  event.target.value,
                                )
                              }
                              onChange={(event) =>
                                this.onChange(
                                  [
                                    'rooms',
                                    indexRoom,
                                    'options',
                                    indexOption,
                                    'saleCost',
                                  ],
                                  event.target.value,
                                )
                              }
                            />
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="form-group">
                            <label
                              htmlFor="typeRoom"
                              style={{
                                fontWeight: '400',
                              }}
                            >
                              TIPO DE HABITACIÓN
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="typeRoom"
                              value={option.description}
                              required
                              placeholder="P.e. Sencilla"
                              onChange={(event) =>
                                this.onChange(
                                  [
                                    'rooms',
                                    indexRoom,
                                    'options',
                                    indexOption,
                                    'description',
                                  ],
                                  event.target.value,
                                )
                              }
                            />
                          </div>
                        </Col>
                        <Col md={2} style={{ marginTop: 25 }}>
                          <span>
                            <Button
                              bsStyle="danger"
                              onClick={this.removeOption(
                                indexRoom,
                                indexOption,
                              )}
                            >
                              -
                            </Button>
                          </span>
                          {room.options.length - 1 === indexOption && (
                            <span style={{ paddingLeft: 8 }}>
                              <Button
                                bsStyle="primary"
                                onClick={this.addOption(indexRoom)}
                              >
                                +
                              </Button>
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row style={{ marginLeft: 2 }}>
                        <CommissionLabel
                          price={option.saleCost}
                          buyprice={option.purchaseCost}
                        />
                      </Row>
                    </Row>
                  ))}
                  <hr />
                </div>
              ))}
              <Row>
                <Col md={12}>
                  <div>
                    <Button bsStyle="primary" onClick={this.addRoom}>
                      Agregar habitación
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={'pull-right'} style={{ marginBottom: 15 }}>
                    <Button
                      bsStyle="primary"
                      style={{ marginRight: 10 }}
                      onClick={this.onCloseModal}
                    >
                      Regresar
                    </Button>
                    <Button fill bsStyle="primary" onClick={this.onAdd}>
                      Guardar
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>
          </Grid>
        </Loader>
      </Modal>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(lodgingSaleAdd);



// WEBPACK FOOTER //
// ./src/views/Sales/cardsSale/lodgingSaleAdd.js